<template>
    <div style="height: 100%" class="bubble" :style="'background-image: url(' + image + ')'"></div>
</template>

<script>
    export default {
        name: 'Bubble',
        props: [ 'image' ],
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bubble {
        position: fixed;
        top: 0;
        left: 0;
        height: 100px !important;
        border-radius: 100%;
        width: 100px;
        box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
        /*background-image: url('../assets/phils/1.png');*/
        background-size: cover;
        background-position: center;
    }
</style>
